/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbPlageHoraireDetailDto
 */
export interface FcbPlageHoraireDetailDto {
    /**
     * 
     * @type {number}
     * @memberof FcbPlageHoraireDetailDto
     */
    numero?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbPlageHoraireDetailDto
     */
    idplage?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbPlageHoraireDetailDto
     */
    heureDebut?: string | null;
}

/**
 * Check if a given object implements the FcbPlageHoraireDetailDto interface.
 */
export function instanceOfFcbPlageHoraireDetailDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbPlageHoraireDetailDtoFromJSON(json: any): FcbPlageHoraireDetailDto {
    return FcbPlageHoraireDetailDtoFromJSONTyped(json, false);
}

export function FcbPlageHoraireDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbPlageHoraireDetailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'numero': !exists(json, 'numero') ? undefined : json['numero'],
        'idplage': !exists(json, 'idplage') ? undefined : json['idplage'],
        'heureDebut': !exists(json, 'heureDebut') ? undefined : json['heureDebut'],
    };
}

export function FcbPlageHoraireDetailDtoToJSON(value?: FcbPlageHoraireDetailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'numero': value.numero,
        'idplage': value.idplage,
        'heureDebut': value.heureDebut,
    };
}

